import { StorageMaintenanceState } from "@/models/storageMaintenance/interfaces/storageMaintenance";

export const getDefaultState = (): StorageMaintenanceState => {
  return {
    userSelectionsStorage: Date.now(),
    iwSettingsTimeStamp: 0,
    venueTimeStamp: 0,
    vendorTimeStamp: 0,
    itemsTimeStamp: 0
  };
};

// initial state
export const state = getDefaultState();
